import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/admin/stats').then(r => setStats(r.data));
  }, []);

  const cards = stats ? [
    { icon: '🎫', value: stats.total, label: 'Total Tickets', cls: 'gold' },
    { icon: '✅', value: stats.approved, label: 'Approved', cls: 'green' },
    { icon: '⏳', value: stats.pending, label: 'Pending', cls: 'yellow' },
    { icon: '❌', value: stats.declined, label: 'Declined', cls: 'red' },
    { icon: '🆓', value: stats.free, label: 'Free Tickets', cls: '' },
    { icon: '🚪', value: stats.checkedIn, label: 'Checked In', cls: '' },
    { icon: '🏷️', value: stats.totalCoupons, label: 'Total Coupons', cls: '' },
    { icon: '📎', value: stats.usedCoupons, label: 'Used Coupons', cls: '' }
  ] : [];

  return (
    <div>
      <div className="admin-page-header">
        <h1 className="admin-page-title">Dashboard</h1>
        <p className="admin-page-sub">Grand Opening ALS — June 6, 2026</p>
      </div>

      {/* ─── Big Action Buttons ─── */}
      <div className="dash-actions">
        <button className="dash-action-btn dash-scan" onClick={() => navigate('/admin/scan')}>
          <span className="dash-action-icon">📷</span>
          <div>
            <div className="dash-action-title">Open Scanner</div>
            <div className="dash-action-sub">Scan attendee QR codes</div>
          </div>
        </button>
        <button className="dash-action-btn dash-tickets" onClick={() => navigate('/admin/tickets')}>
          <span className="dash-action-icon">🎫</span>
          <div>
            <div className="dash-action-title">View All Tickets</div>
            <div className="dash-action-sub">Manage & approve bookings</div>
          </div>
        </button>
      </div>

      {/* ─── Stats ─── */}
      <div className="admin-stats">
        {cards.map((c, i) => (
          <div key={i} className={`admin-stat ${c.cls}`}>
            <div className="admin-stat-icon">{c.icon}</div>
            <div className="admin-stat-value">{c.value ?? '—'}</div>
            <div className="admin-stat-label">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
